import { TicketService } from '@/services/ticket.service'
import { queryOptions } from '@tanstack/react-query'

export const listPendingTicketsQuery = queryOptions({
  queryKey: ['list-pending-tickets'],
  queryFn: TicketService.listPending,
})

export const listDeskTicketsQuery = queryOptions({
  queryKey: ['list-desk-tickets'],
  queryFn: TicketService.listInProgress,
})

export const listAgentTicketsQuery = queryOptions({
  queryKey: ['list-agent-tickets'],
  queryFn: TicketService.listAgent,
})

export const listFinishedTicketsQuery = queryOptions({
  queryKey: ['list-finished-tickets'],
  queryFn: TicketService.listFinished,
})

export const listTicketMessagesQuery = (ticketId: number) =>
  queryOptions({
    queryKey: ['list-messages', ticketId],
    queryFn: () => TicketService.listMessagesByTicketId(ticketId),
  })
